import React from 'react';

import { withInteractiveStore } from './TemplateWithInteractiveStore';
import { Attention, ContentTypeIcon, MiniHeader, SanitizedHtml, SimQuestion } from '.';
import { SimObjectives } from './SimObjectives';
import { SimPanels } from './SimPanels';

const SimulationWithoutStore = ({assets, interactive, ...props}) => {
  const { attention, bg, debrief={}, objectives, resourcesLink, task={}, taskBg, title, id, mission={}, minutes, responses } = interactive;

  const miniHeaderWithResources = (
    <MiniHeader
      title={<>{"Simulation "}<span className='font-regular'>&nbsp;|&nbsp;</span>{` ${title}`}</>} 
      menu={true}
      btn={true}
    >
      <div className="dinfos-sim__res">
        <a href={resourcesLink} className="btn dinfos-btn dinfos-sim__res-btn" target="_blank" rel="noopener noreferrer">Resources<i className="fas fa-external-link-alt"></i><span className="sr-only"> Opens in a new window</span></a>
      </div>
    </MiniHeader>
  )

  const renderActiveClass = (screenNo) => {
    const activeClass =  'dinfos-sim__screen--active';
    if (props.window && props.window.activeScreen === screenNo) {
      return activeClass;
    } else if (screenNo === 1) {
      return activeClass;
    } else {
      return '';
    }
  }

  
  if (props.window) {
    props.window.responses = responses
  }

  if (!mission || !debrief || !task ) {
    return ''
  }

  return (
    <div id="interactive-template" ref={props.forwardedRef}>
      <script id="fc-script">
        window.responses = {JSON.stringify(responses)}
      </script>

      <article className="dinfos-sim" id={id} data-intv>
        <div className="dinfos-sim__menu-bg"></div>

        {/* Overview screen */}
        <section className="dinfos-sim__screen dinfos-sim__screen--overview dinfos-sim__screen--active" data-screen="1">
          
          { bg && bg.src ? 
            <div className="dinfos-intv__bg">
              <img src={assets[bg.src]} alt="" data-src={bg && bg.src ? bg.src : null}/>
            </div>
          : '' }

          <div className="container">
          
            <header className="dinfos-intv-header">
              <div className="dinfos-intv-header__bg-icon" aria-hidden="true"> 
                <ContentTypeIcon id="ct_simulation"/>
              </div>
              <h1 className="dinfos-intv-header__title">{title}</h1>
              <div className="dinfos-intv-header__supertitle">
                <span>Simulation  </span><span><i className='far fa-clock'></i>{`  ${minutes ?  minutes : 0} min`}</span>
              </div>
            </header>

            <Attention {...attention} />

          </div>
        </section>

        {/* Story: Mission */}
        <section className={`dinfos-sim__screen dinfos-sim__screen--story  dinfos-sim__screen--${mission.format} ${renderActiveClass(2)}`} data-screen="2">
        
          {mission.format === 'panels' ?
            <div className="dinfos-sim__story-bg">
              {mission.image && mission.image.src ?
                <img src={assets[mission.image.src]} aria-hidden="true" alt="" data-src={mission.image.src} /> 
              : '' }
              <div className={`dinfos-sim__story-bg-overlay dinfos-sim__story-bg-overlay--${mission.format}`}></div>
            </div>
          : '' }

          {miniHeaderWithResources}

          <div className="dinfos-sim__story d-flex">

            {mission.format === 'panels' && mission.cols ?

              <div className="row dinfos-sim__panels-track dinfos-drag-scroll-x">
                <div className="col-12 col-lg-3 d-flex align-items-center">
                  <h3 className="dinfos-sim__story-title">Your Mission</h3>
                </div>
                
                <SimPanels cols={mission.cols} assets={assets} />

                { objectives ?
                  <SimObjectives {...objectives} />
                : '' }
               
              </div>

            : mission.format === 'text' ? 

              <div className="dinfos-sim__track dinfos-drag-scroll-x">

                <div className="dinfos-sim__story-bg">
                  {mission.image && mission.image.src ?
                    <img src={assets[mission.image.src]} aria-hidden="true" alt="" data-src={mission.image.src} /> 
                  : '' }
                  <div className={`dinfos-sim__story-bg-overlay dinfos-sim__story-bg-overlay--${mission.format}`}></div>
                </div>

                <div className="dinfos-sim__story-text-wrapper row flex-lg-nowrap">

                  <div className="col-12 col-lg-7"></div>
                  <div className="col-12 col-lg-5">
                    <h3 className="dinfos-sim__story-title">Your Mission</h3>
                    <SanitizedHtml className="dinfos-sim__story-text" content={mission.text} />
                  </div>

                  { objectives ?
                    <SimObjectives {...objectives} />
                  : '' }

                </div>

              </div>
            : '' }
          </div>
        </section>
        
        {/* Questions: Path question and "quiz" questions */}
        <section className={`dinfos-sim__screen dinfos-sim__screen--task ${renderActiveClass(3)}`} data-screen="3">
          
          {miniHeaderWithResources}
          
          {/* Path Question */}
          {task.question ?
         
            <SimQuestion
              {...task.question}
              bg={taskBg}
              count={1}
              assets={assets}
              total={task.paths[0].questions.length + 1 }
              id={id + '-select-path'}
              show={true}
              select_path={true}
            />
          : '' }

          {/* Paths */}
          { !task.paths ? '' : 
            task.paths.map((path, pathIndex) => (
              <div key={pathIndex} data-path={pathIndex} className={task.question ? "d-none" : ''}>

                {/* "Quiz" Questions */}
                {path.questions.map((question, qIndex) => (
                  <SimQuestion
                    key={qIndex}
                    assets={assets}
                    index={qIndex}
                    {...question}
                    bg={taskBg}
                    count={qIndex + (task.question ? 2 : 1)}
                    total={path.questions.length + (task.question ? 1 : 0) }
                    id={`${id}-path-${pathIndex}-q-${qIndex}`}
                    // id={`${id}-path-${pathIndex + 1}-q-${qIndex + 1}`} // twig used loop.index, not loop.index0
                    show={qIndex === 0}
                    end={qIndex === path.questions.length - 1}
                    select_path={false}
                  />
                ))}

              </div>
            ))
          }

        </section>

        {/* Story: Debrief */}
        <section className={`dinfos-sim__screen dinfos-sim__screen--debrief ${renderActiveClass(4)}`} data-screen="4">
          <div className="dinfos-sim__story-bg">
            {debrief.image && debrief.image.src ?
              <img src={assets[debrief.image.src]} aria-hidden="true" alt="" data-src={debrief.image.src}/>
            : '' }
            <div className={`dinfos-sim__story-bg-overlay dinfos-sim__story-bg-overlay--${debrief.format}`}></div>
          </div>

          <MiniHeader
            title={<>{"Simulation "}<span className='font-regular'>&nbsp;|&nbsp;</span>{` ${title}`}</>} 
            btn={true}
          />
          
          <div className="dinfos-sim__story d-flex">
            

              { debrief.format === 'text' ?
                <div className="row w-100">
                  <div className="col-12 col-md-8 col-lg-6 offset-lg-3 my-5 my-md-0">
                    <h3 className="dinfos-sim__story-title">Your Debrief</h3>
                    <SanitizedHtml className="dinfos-sim__story-debrief" content={debrief.text} />
                  </div>

                  <div className="col-12 col-md-4 col-lg-3 my-5 my-md-0 d-flex flex-column justify-content-center">
                    <h3 className="dinfos-sim__story-next-title">Check Your Score</h3>
                    <div className="dinfos-sim__story-next-instr">Let's see how you did!</div>
                    <button type="button" className="btn dinfos-btn dinfos-btn--primary dinfos-btn--action align-self-center align-self-md-start" data-score-sim>Continue</button>
                  </div>
                </div>

              : debrief.format === 'panels' && debrief.cols ? 

                <div className="row dinfos-sim__panels-track dinfos-drag-scroll-x">
                  <div className="col-12 col-lg-3 d-flex align-items-center">
                    <h3 className="dinfos-sim__story-title">Your Debrief</h3>
                  </div>
                  
                  <SimPanels cols={debrief.cols} assets={assets} />

                  <div className="col-12 col-lg-3 my-5 my-lg-0 d-flex flex-column justify-content-center">
                    <h3 className="dinfos-sim__story-next-title">Check Your Score</h3>
                    <div className="dinfos-sim__story-next-instr">Let's see how you did!</div>
                    <button type="button" className="btn dinfos-btn dinfos-btn--primary dinfos-btn--action align-self-center align-self-md-start" data-score-sim>Continue</button>
                  </div>

                </div>

              : ''
            }

          </div>
        </section>

        {/* End screen */}
        <section className={`dinfos-sim__screen dinfos-sim__screen--results  ${renderActiveClass(5)}`} data-screen="5">
          
          <MiniHeader title={<>{"Simulation "}<span className='font-regular'>&nbsp;|&nbsp;</span>{` ${title}`}</>} />

          <div className="container">
            <div className="dinfos-result">

              <div className="dinfos-result__score" data-percent="">
                <svg className="dinfos-result__circle" perserveaspectratio="xMinYMid" viewport="0 0 100 100" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <circle className="dinfos-result__circle-bg" r="45" cx="50" cy="50" fill="transparent"  strokeDashoffset="0"></circle>
                  <circle className="dinfos-result__circle-bar"  r="45" cx="50" cy="50" fill="transparent" strokeDashoffset="0"></circle>
                </svg>
                <div className="dinfos-result__percent"></div>
                <div className="dinfos-result__raw"><span className="dinfos-result__correct"></span> of <span className="dinfos-result__total"></span> Correct</div>
              </div>

              <div className="dinfos-result__title"></div>
              <hr className="dinfos-result__hr" />
              <div className="dinfos-result__feedback"></div>

              <div className="dinfos-result__end-buttons">
                <button type="button" className="btn dinfos-btn dinfos-btn--tertiary dinfos-btn--icon-after" data-reload>Try Again <i className="fas fa-redo fa-icon"></i></button>
                <a href="/Search-Results/Practice/" className="btn dinfos-btn dinfos-btn--primary dinfos-btn--action">Explore More</a>
              </div>

            </div>
          </div> 

        </section>
      
      </article>
    </div>
  )
}

export const Simulation = withInteractiveStore(
  SimulationWithoutStore,
);